module.exports = __webpack_public_path__ + "img/v_1.9d3df07b.svg";